import { z } from 'zod';

// Report status
export const portalReportStatusSchema = z.enum(['draft', 'published']);
export type PortalReportStatus = z.infer<typeof portalReportStatusSchema>;

// Portal Report schema
export const portalReportSchema = z.object({
  id: z.string(),
  portalId: z.string(),
  title: z.string(),
  content: z.string(),
  status: portalReportStatusSchema,
  generatedAt: z.string().nullable(),
  publishedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type PortalReport = z.infer<typeof portalReportSchema>;

// Request schemas
export const generateReportRequestSchema = z.object({
  instructions: z.string().optional(), // Consultant's instructions for AI
});

export type GenerateReportRequest = z.infer<typeof generateReportRequestSchema>;

export const updateReportRequestSchema = z.object({
  title: z.string().optional(),
  content: z.string().optional(),
});

export type UpdateReportRequest = z.infer<typeof updateReportRequestSchema>;

// Response schemas
export const portalReportResponseSchema = z.object({
  report: portalReportSchema,
});

export type PortalReportResponse = z.infer<typeof portalReportResponseSchema>;

export const portalReportsListResponseSchema = z.object({
  reports: z.array(portalReportSchema),
});

export type PortalReportsListResponse = z.infer<typeof portalReportsListResponseSchema>;
